<template>
  <b-container fluid>
    <b-row>
      <b-col class="top_bar" />
    </b-row>
    <b-row :style="{ 'margin-bottom': cardPosition }"
      ><b-col><div class="page_title">My Courses</div></b-col></b-row
    >
    <b-row class="mb-3" :key="i" v-for="i in rowCount">
      <b-col class="col-1"></b-col>
      <b-col
        class="col-4 mr-5 mb-5"
        :key="item._id"
        v-for="item in getItems(i)"
      >
        <course-card :course="item"
      /></b-col>
    </b-row>
  </b-container>
</template>

<script>
import CourseCard from "../../components/Courses/CourseCard";
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";

export default {
  name: "Courses",
  components: { CourseCard },
  data: function() {
    return {
      itemsPerRow: 2
    };
  },
  computed: {
    ...mapGetters({
      courses: StoreConstants.GETTERS.COURSES
    }),
    rowCount: function() {
      return this.courses
        ? Math.ceil(this.courses.length / this.itemsPerRow)
        : 0;
    },
    cardPosition: function() {
      return this.rowCount > 1 ? "50px" : "200px";
    }
  },
  methods: {
    getItems(rowIndex) {
      return this.courses
        ? this.courses.slice(
            (rowIndex - 1) * this.itemsPerRow,
            (rowIndex - 1) * this.itemsPerRow + this.itemsPerRow
          )
        : [];
    }
  }
};
</script>

<style scoped></style>
